import React, { useMemo } from 'react';
import { LFC } from '../../../Legacy';
import { Table } from '../../../ui/Table';
import { useResolve } from '../../Container';
import { ExportConfiguration, ExportService } from './ExportService';

export const ExportPreview: LFC<ExportConfiguration> = (config) => {

    const exporter = useResolve(ExportService);
    const [head, ...body] = useMemo(() => exporter.export(config), [config]);

    if (!head) return null;

    return <Table>
        <Table.Head>
            <Table.Row>
                {head.map(c => <Table.Cell key={c.id}>{c.value?.toString() ?? ''}</Table.Cell>)}
            </Table.Row>
        </Table.Head>
        <Table.Body>
            {body.map((r, i) =>
                <Table.Row key={i}>
                    {r.map(c => <Table.Cell key={c.id}>{c.value?.toString() ?? ''}</Table.Cell>)}
                </Table.Row>
            )}
        </Table.Body>
    </Table>;
};
